<template>
  <b-col>
    <b-row align-v="center">
      <b-button
        v-show="!hideCreateCriteriaSubLo"
        variant="outline-primary"
        size="sm"
        class="button__create-criteria"
        :disabled="disabled"
        @click="showModalCriteria = true"
      >
        Create a criteria
      </b-button>
    </b-row>

    <modal-create-or-update-criteria
      :ultimate-learning-outcome="ultimateLearningOutcome"
      :sub-learning-outcome="subLearningOutcome"
      :show.sync="showModalCriteria"
    />
  </b-col>
</template>

<script>
import ModalCreateOrUpdateCriteria from './ModalCreateOrUpdateCriteria';
import { LearningOutcome } from '@/models/LearningOutcome';
export default {
  components: {
    ModalCreateOrUpdateCriteria
  },

  props: {
    ultimateLearningOutcome: {
      type: LearningOutcome,
      default: null
    },
    subLearningOutcome: {
      type: Object,
      default: () => null
    },
    disabled: {
      type: [Number, Boolean],
      default: false
    },
    hideCreateCriteriaSubLo: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModalCriteria: false
    };
  }
};
</script>
